import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React from 'react';
import { View, Text, Pressable } from 'react-native';
import OrderArrowRight from '../../../assets/images/rn/OrderArrowRight';
import { ModeType } from './index';
import Input from './components/Input';
import Select from './components/Select';
import Answer from './components/Answer';
import Email from './components/Email';
import { FileUpload } from './components/FileUpload';
import { MixedFileUpload } from './components/MixedFileUpload';
import { WebFormOrder } from '../../WebformOrder/rn';
import { Button } from '../../Button/rn';
import PhoneNumber from './components/PhoneNumber';
import RequestEmail from './components/RequestEmail';
import InputWithRegion from './components/InputWithRegion';
import DropdownList from './components/DropdownList';
import { useLocale } from '../../LocaleProvider/rn';
import styles from './style';
import { isValidValue } from './config';
import { useTracking } from '../../../hooks/rn/useTracking';
import { TRACKING_TARGET } from '../../../utils/tracking/constants';
export var ComponentType;
(function (ComponentType) {
  ComponentType["Input"] = "Input";
  ComponentType["InputWithRegion"] = "InputWithRegion";
  ComponentType["Select"] = "Select";
  ComponentType["Answer"] = "Answer";
  ComponentType["Email"] = "Email";
  ComponentType["FileUpload"] = "FileUpload";
  ComponentType["MixedFileUpload"] = "MixedFileUpload";
  ComponentType["WebFormOrder"] = "WebFormOrder";
  ComponentType["PhoneNumber"] = "PhoneNumber";
  ComponentType["RequestEmail"] = "RequestEmail";
  ComponentType["DropdownList"] = "DropdownList";
})(ComponentType || (ComponentType = {}));
var componentMap = {
  Input: Input,
  Select: Select,
  Answer: Answer,
  Email: Email,
  FileUpload: FileUpload,
  MixedFileUpload: MixedFileUpload,
  InputWithRegion: InputWithRegion,
  WebFormOrder: WebFormOrder,
  PhoneNumber: PhoneNumber,
  RequestEmail: RequestEmail,
  DropdownList: DropdownList
};
var ViewFormItem = function ViewFormItem(props) {
  var _props$trackingData2;
  var label = props.label,
    mode = props.mode,
    component = props.component,
    _props$trackingData = props.trackingData,
    trackingData = _props$trackingData === void 0 ? {} : _props$trackingData; // if (props.trackingData?.trackingdataBasic) {
  //   props.trackingData.trackingdataBasic.field_name = label;
  // }

  var _useTracking = useTracking(_objectSpread(_objectSpread({}, props), {}, {
      trackingData: _objectSpread(_objectSpread({}, props.trackingData || {}), {}, {
        trackingdataBasic: _objectSpread(_objectSpread({}, ((_props$trackingData2 = props.trackingData) === null || _props$trackingData2 === void 0 ? void 0 : _props$trackingData2.trackingdataBasic) || {}), {}, {
          field_name: label
        })
      })
    })),
    trackingImpressionProps = _useTracking.trackingImpressionProps; // useEffect(() => {
  //   // TODO: 在 RN 的 tracker 写好之前，先手动触发 impression 上报
  //   // 因为 button 的 click上报和 impression 上报的字段是一样的，所以这里直接用 click 的上报数据
  //   if (Platform.OS === 'web') {
  //     props.trackingData &&
  //       dataMaintainer.tracker?.dispatchTrack({
  //         operation: TRACKING_OPERATION.IMPRESSION,
  //         section: props.trackingData.trackingsection,
  //         target: TRACKING_TARGET.webform,
  //         data: { viewed_objects: [{ ...(props.trackingData.trackingdataBasic || {}), field_name: label }] },
  //       });
  //   }
  // }, []);

  var Component = componentMap[component] ? componentMap[component] : Input;
  return /*#__PURE__*/React.createElement(Pressable, _extends({
    onPress: [ModeType.Checking, ModeType.Edit].includes(mode) && ![ComponentType.FileUpload].includes(component) ? props.onSelectFormItem : undefined
  }, trackingImpressionProps), [ComponentType.Select, ComponentType.WebFormOrder].includes(component) ? /*#__PURE__*/React.createElement(Component, _extends({}, props, {
    trackingData: _objectSpread(_objectSpread({}, trackingData), {}, {
      trackingdataBasic: _objectSpread(_objectSpread({}, (trackingData === null || trackingData === void 0 ? void 0 : trackingData.trackingdataBasic) || {}), {}, {
        field_name: label
      })
    })
  })) : /*#__PURE__*/React.createElement(View, {
    style: styles.webformItemViewWrapper
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.webformItemViewContent
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.webformItemViewLabel
  }, label), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Component, _extends({}, props, {
    trackingData: _objectSpread(_objectSpread({}, trackingData), {}, {
      trackingdataBasic: _objectSpread(_objectSpread({}, (trackingData === null || trackingData === void 0 ? void 0 : trackingData.trackingdataBasic) || {}), {}, {
        field_name: label
      })
    })
  })))), [ModeType.Checking, ModeType.Edit].includes(mode) && ![ComponentType.FileUpload, Component.MixedFileUpload].includes(component) ? /*#__PURE__*/React.createElement(OrderArrowRight, {
    style: styles.webformItemViewIcon
  }) : null));
};
var EditFormItem = function EditFormItem(props) {
  var _props$trackingData4;
  var label = props.label,
    component = props.component,
    required = props.required,
    supporting = props.supporting,
    isCaseCreation = props.isCaseCreation,
    _props$trackingData3 = props.trackingData,
    trackingData = _props$trackingData3 === void 0 ? {} : _props$trackingData3; // useEffect(() => {
  //   // TODO: 在 RN 的 tracker 写好之前，先手动触发 impression 上报
  //   // 因为 button 的 click上报和 impression 上报的字段是一样的，所以这里直接用 click 的上报数据
  //   if (Platform.OS === 'web') {
  //     props.trackingData &&
  //       dataMaintainer.tracker?.dispatchTrack({
  //         operation: TRACKING_OPERATION.IMPRESSION,
  //         section: props.trackingData.trackingsection,
  //         target: TRACKING_TARGET.webform,
  //         data: { viewed_objects: [{ ...(props.trackingData.trackingdataBasic || {}), field_name: label }] },
  //       });
  //   }
  // }, []);
  // if (props.trackingData?.trackingdataBasic) {
  //   props.trackingData.trackingdataBasic.field_name = label;
  // }

  var _useTracking2 = useTracking(_objectSpread(_objectSpread({}, props), {}, {
      trackingData: _objectSpread(_objectSpread({}, props.trackingData || {}), {}, {
        trackingdataBasic: _objectSpread(_objectSpread({}, ((_props$trackingData4 = props.trackingData) === null || _props$trackingData4 === void 0 ? void 0 : _props$trackingData4.trackingdataBasic) || {}), {}, {
          field_name: label
        })
      })
    })),
    trackingImpressionProps = _useTracking2.trackingImpressionProps;
  var Component = componentMap[component] ? componentMap[component] : Input;
  return [ComponentType.DropdownList, ComponentType.Select, ComponentType.WebFormOrder].includes(component) ? /*#__PURE__*/React.createElement(Pressable, _extends({
    onPress: [ComponentType.DropdownList, ComponentType.Select].includes(component) ? props.onSelectFormItem : undefined
  }, trackingImpressionProps), /*#__PURE__*/React.createElement(Component, _extends({}, props, {
    trackingData: _objectSpread(_objectSpread({}, trackingData), {}, {
      trackingdataBasic: _objectSpread(_objectSpread({}, (trackingData === null || trackingData === void 0 ? void 0 : trackingData.trackingdataBasic) || {}), {}, {
        field_name: label
      })
    })
  }))) : /*#__PURE__*/React.createElement(View, _extends({
    style: styles.webformItemEditWrapper
  }, trackingImpressionProps), /*#__PURE__*/React.createElement(View, null, (!isCaseCreation || component === ComponentType.Answer) && /*#__PURE__*/React.createElement(View, {
    style: styles.webformItemLabel
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.webformItemLabelText
  }, label), required ? /*#__PURE__*/React.createElement(Text, {
    style: styles.webformItemRequired
  }, "*") : null), !isCaseCreation && supporting && (component === ComponentType.FileUpload || component === ComponentType.MixedFileUpload) ? /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Text, {
    style: styles.webformItemTips
  }, supporting)) : null, /*#__PURE__*/React.createElement(Component, _extends({}, props, {
    trackingData: _objectSpread(_objectSpread({}, trackingData), {}, {
      trackingdataBasic: _objectSpread(_objectSpread({}, (trackingData === null || trackingData === void 0 ? void 0 : trackingData.trackingdataBasic) || {}), {}, {
        field_name: label
      })
    }),
    placeholder: component === ComponentType.Answer ? supporting : undefined
  }))));
};
var EditFormItemOnly = function EditFormItemOnly(props) {
  var component = props.component,
    value = props.value;
  var _useLocale = useLocale(),
    trans = _useLocale.trans;
  var _React$useState = React.useState(value),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    text = _React$useState2[0],
    setText = _React$useState2[1];
  var Component = componentMap[component] ? componentMap[component] : Input;
  var handleChange = function handleChange(value) {
    if ([ComponentType.Input, ComponentType.InputWithRegion, ComponentType.Answer, ComponentType.Email, ComponentType.PhoneNumber, ComponentType.RequestEmail].includes(component)) {
      setText(value);
    } else {
      var _props$onChange, _props$onPrev;
      (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, value);
      (_props$onPrev = props.onPrev) === null || _props$onPrev === void 0 ? void 0 : _props$onPrev.call(props);
    }
  };
  var handleSave = function handleSave() {
    var _props$onChange2;
    (_props$onChange2 = props.onChange) === null || _props$onChange2 === void 0 ? void 0 : _props$onChange2.call(props, text); // 需要校验

    if (isValidValue(text, props)) {
      var _props$onPrev2;
      (_props$onPrev2 = props.onPrev) === null || _props$onPrev2 === void 0 ? void 0 : _props$onPrev2.call(props);
    }
  };
  return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Component, _extends({}, props, {
    onChange: handleChange
  })), [ComponentType.Input, ComponentType.Answer, ComponentType.Email, ComponentType.PhoneNumber, ComponentType.InputWithRegion, ComponentType.RequestEmail].includes(component) ? /*#__PURE__*/React.createElement(Button, {
    type: "primary",
    trackingData: _objectSpread(_objectSpread({}, props.trackingData), {}, {
      trackingtarget: TRACKING_TARGET.button,
      trackingdataTarget: {
        button_text: trans('webform_save')
      }
    }),
    styles: {
      containerStyle: {
        marginLeft: 8,
        marginTop: 8,
        marginBottom: 8,
        marginRight: 8,
        paddingBottom: 14,
        paddingTop: 14
      }
    },
    disabled: !isValidValue(text, props),
    text: trans('webform_save'),
    onClick: handleSave
  }) : null);
};
export var WebFormItem = function WebFormItem(props) {
  var mode = props.mode;
  return /*#__PURE__*/React.createElement(View, null, [ModeType.View, ModeType.Checking].includes(mode) ? /*#__PURE__*/React.createElement(ViewFormItem, props) : null, [ModeType.Edit].includes(mode) ? /*#__PURE__*/React.createElement(EditFormItem, props) : null, [ModeType.EditItem].includes(mode) ? /*#__PURE__*/React.createElement(EditFormItemOnly, props) : null);
};